import "../chunk-MQXBDTVK.js"; // src/connectors/walletConnectLegacy.ts

import { WalletConnectLegacyConnector } from "@wagmi/connectors/walletConnectLegacy";
export { WalletConnectLegacyConnector };